import { IDeleteManutencaoEquipObraUseCase } from "../../../presentation/useCases/delete/delete_manutencao_equip_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteManutencaoEquipObraUseCase
 */

export class DeleteManutencaoEquipObraUseCase implements IDeleteManutencaoEquipObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(idManutencaoEquipObra: number): Promise<void> {
    await this.repository.deleteManutencaoEquipObra(idManutencaoEquipObra);
  }

}
